module.exports = __webpack_public_path__ + "static/screen1-7f19ac17065cca04da00f51e88d0014b.png";